var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "aero4good-footer-link",
        attrs: { target: "_blank", href: "https://aero4good.org/" }
      },
      [
        _c("span", [_vm._v("Partenaire")]),
        _vm._v(" "),
        _c("img", { attrs: { src: "/imgs/icons/logo-aero4good-white.svg" } })
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e86032c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e86032c4","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Aero4goodFooterLink.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e86032c4","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Aero4goodFooterLink.vue
// module chunks = 1 2 3